import React, { useState, useEffect } from "react";
import axios from "axios";

const Register = () => {
  const [formData, setFormData] = useState({
    id: "",
    firstName: "",
    lastName: "",
    username: "",
    password: "",
    confirmPassword: "",
    email: "",
    phoneNumber: "",
    gender: "",
    favorites: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
  });

  const [usersData, setUsersData] = useState([]);
  const [showToast, setShowToast] = useState({ show: false, message: "", type: "" });

  useEffect(() => {
    // Fetch existing users data from Firebase
    axios
      .get("https://java-tutorial-c5fac-default-rtdb.firebaseio.com/JMeter_Users_data.json")
      .then((response) => {
        setUsersData(response.data || {});
      })
      .catch((error) => {
        console.error("Error fetching users data:", error);
      });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check for duplicate ID or email
    const isDuplicate = Object.values(usersData).some(
      (user) => user.id === formData.id || user.email === formData.email
    );

    if (isDuplicate) {
      // Show error toast for duplicate records
      setShowToast({ show: true, message: "User ID or Email already exists!", type: "danger" });
      return;
    }

    // Ensure password and confirmPassword match
    if (formData.password !== formData.confirmPassword) {
      setShowToast({ show: true, message: "Passwords do not match!", type: "danger" });
      return;
    }

    try {
      // Add new user to Firebase
      await axios.post(
        "https://java-tutorial-c5fac-default-rtdb.firebaseio.com/JMeter_Users_data.json",
        formData
      );

      // Show success toast
      setShowToast({ show: true, message: `Congratulations ${formData.firstName}, you have successfully registered!`, type: "success" });

      // Reset form data after successful registration
      setFormData({
        id: "",
        firstName: "",
        lastName: "",
        username: "",
        password: "",
        confirmPassword: "",
        email: "",
        phoneNumber: "",
        gender: "",
        favorites: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zipCode: "",
        country: "",
      });

    } catch (error) {
      console.error("Error registering user:", error);
      setShowToast({ show: true, message: "Error registering user!", type: "danger" });
    }
  };

  return (
    <div className="container mt-5">
      <h2>Register</h2>
      <form onSubmit={handleSubmit}>
        {/* Personal Information */}
        <div className="mb-3">
          <label htmlFor="id" className="form-label">
            User ID
          </label>
          <input
            type="text"
            className="form-control"
            id="id"
            name="id"
            value={formData.id}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="firstName" className="form-label">
            First Name
          </label>
          <input
            type="text"
            className="form-control"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="lastName" className="form-label">
            Last Name
          </label>
          <input
            type="text"
            className="form-control"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="username" className="form-label">
            Username
          </label>
          <input
            type="text"
            className="form-control"
            id="username"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            Email
          </label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="password" className="form-label">
            Password
          </label>
          <input
            type="password"
            className="form-control"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="confirmPassword" className="form-label">
            Confirm Password
          </label>
          <input
            type="password"
            className="form-control"
            id="confirmPassword"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="phoneNumber" className="form-label">
            Phone Number
          </label>
          <input
            type="text"
            className="form-control"
            id="phoneNumber"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="gender" className="form-label">
            Gender
          </label>
          <select
            className="form-control"
            id="gender"
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            required
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="mb-3">
          <label htmlFor="favorites" className="form-label">
            Favorites
          </label>
          <input
            type="text"
            className="form-control"
            id="favorites"
            name="favorites"
            value={formData.favorites}
            onChange={handleChange}
          />
        </div>

        {/* Address Information */}
        <div className="mb-3">
          <label htmlFor="address1" className="form-label">
            Address 1
          </label>
          <input
            type="text"
            className="form-control"
            id="address1"
            name="address1"
            value={formData.address1}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="address2" className="form-label">
            Address 2
          </label>
          <input
            type="text"
            className="form-control"
            id="address2"
            name="address2"
            value={formData.address2}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="city" className="form-label">
            City
          </label>
          <input
            type="text"
            className="form-control"
            id="city"
            name="city"
            value={formData.city}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="state" className="form-label">
            State
          </label>
          <input
            type="text"
            className="form-control"
            id="state"
            name="state"
            value={formData.state}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="zipCode" className="form-label">
            Zip Code
          </label>
          <input
            type="text"
            className="form-control"
            id="zipCode"
            name="zipCode"
            value={formData.zipCode}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="country" className="form-label">
            Country
          </label>
          <input
            type="text"
            className="form-control"
            id="country"
            name="country"
            value={formData.country}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" className="btn btn-primary">
          Register
        </button>
      </form>

      {/* Toast Notification */}
      {showToast.show && (
        <div className={`toast show position-fixed top-0 end-0 p-3 bg-${showToast.type}`} role="alert">
          <div className={`toast-header text-white bg-${showToast.type}`}>
            <strong className="me-auto">Notification</strong>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={() => setShowToast({ ...showToast, show: false })}
            ></button>
          </div>
          <div className="toast-body">{showToast.message}</div>
        </div>
      )}
    </div>
  );
};

export default Register;
